export default __webpack_public_path__ + "static/media/SAML_OnData_Configuration.bc597687.png";